<div class="fe-capacities-container">
  <div class="spinner-container" *ngIf="spinnerBoolean">
    <div class="spinner"></div>
    <div class="spinner-text">Loading Water Sub Dev Area data...</div>
  </div>

  <div class="table-actions-bar">
    <div class="table-title">Water Sub Development Area</div>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">
      Clear All
    </button>
    <button *ngIf="selectedRows.length > 0" (click)="clearSelection()">
      Clear Select
    </button>
    <button *ngIf="showCancel" (click)="cancelRow()">Cancel</button>
    <button (click)="addRow()">New</button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button (click)="handleDelete()" [disabled]="!selectedRows.length">Delete</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <div class="table-container" [ngClass]="{ hidden: spinnerBoolean }">
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell fixed-width-cell-2">Select</div>
        <div class="table-header-cell" *ngFor="let col of columns">
          <div class="col-wrap">
            <div class="text-wrap">
              {{ col.header }}
              <span *ngIf="col.required" class="required-asterisk" title="Required">*</span>
            </div>
            <div class="filter-icon-container" *ngIf="col.filterable">
              <img
                class="filter-icon"
                [ngClass]="{ 'active-filter': isFilterActive(col.field) }"
                [src]="isFilterActive(col.field) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                width="16"
                height="16"
                alt="Filter"
                [title]="isFilterActive(col.field) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                (click)="openFloatingFilter($event, col.field)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-container">
      <cdk-virtual-scroll-viewport
        itemSize="56"
        class="virtual-scroll-viewport"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
      >
        <div
          class="table-body-row"
          [ngClass]="{ 'new-row': row.isNew }"
          *cdkVirtualFor="let row of data; let i = index"
          (mouseenter)="hoveredRowIndex = i"
          (mouseleave)="hoveredRowIndex = null"
        >
          <div class="table-header-cell fixed-width-cell-2">
            <input
              type="checkbox"
              [checked]="selectedRows.includes(row)"
              (change)="toggleRowSelection(row, $event)"
            />
          </div>

          <!-- Dev Area -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select
                *ngIf="row.isNew; else developmentAreaReadOnly"
                [(ngModel)]="row.developmentArea"
                (ngModelChange)="onDevelopmentAreaSelectionChange(row)"
              >
                <option value="">-- Select Dev Area --</option>
                <option *ngFor="let area of getDevelopmentAreaOptions()" [value]="area">
                  {{ area }}
                </option>
              </select>
              <ng-template #developmentAreaReadOnly>
                <div class="readonly-cell">{{ row.developmentArea }}</div>
              </ng-template>
            </div>
          </div>

          <!-- Sub Dev Area -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <input
                type="text"
                [(ngModel)]="row.subDevAreaName"
                (input)="handleEdit(row)"
                placeholder="Enter Sub Dev Area"
              />
            </div>
          </div>

          <!-- CTB -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <div class="multi-facility-field">
                <div class="facility-tags">
                  <span
                    *ngFor="let ctbValue of row.ctbs"
                    class="facility-chip"
                  >
                    {{ ctbValue }}
                    <span
                      class="remove-chip"
                      (click)="removeCtb(row, ctbValue)"
                    >×</span>
                  </span>
                  <select
                    class="facility-select"
                    (change)="addCtb(row, $event)"
                  >
                    <option value="" disabled selected hidden>Select CTB</option>
                    <option
                      *ngFor="let ctbValue of getCtbOptions()"
                      [value]="ctbValue"
                      [disabled]="row.ctbs.includes(ctbValue)"
                    >
                      {{ ctbValue }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <div class="loading-more" *ngIf="loading">
    <div class="loading-spinner"></div>
    <span>Loading more data...</span>
  </div>

  <div
    class="floating-filter-dropdown"
    #floatingFilterPanel
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <!-- Multi-select filter -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'multi-select'">
      <input
        type="text"
        [(ngModel)]="filterSearch[activeFilter]"
        placeholder="Search..."
      />

      <div *ngIf="isLoadingFilterOptions" class="filter-loading">
        <div class="spinner-small"></div>
        Loading options...
      </div>

      <div *ngIf="!isLoadingFilterOptions" class="filter-options">
        <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
          No options available
        </div>
        <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
          {{ getFilterOptions(activeFilter).length }} options available
        </div>
        <label *ngFor="let option of getFilterOptions(activeFilter)">
          <input
            type="checkbox"
            [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)"
          />
          <span>{{ option }}</span>
        </label>
      </div>

      <div class="filter-buttons">
        <button (click)="applyFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export Water Sub Dev Area</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>
